/**************************************************
 * Nombre:       Dialogo_Politica
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const Dialogo_Politica = ({cerrar, realizado, datos}) => {


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}} sx={{px: 2, color: '#fff'}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 14, textAlign: 'justify'}}>
                    De conformidad con lo dispuesto en el Artículo 15 de la Constitución Política de Colombia, la Ley
                    Estatutaria 1581 de 2012 (por la cual se dictan disposiciones generales para la protección de datos
                    personales), el Decreto Único Reglamentario 1074 de 2015 y demás normas concordantes,
                    complementarias o modificatorias vigentes en la República de Colombia, el usuario, en su calidad de
                    titular de la información, otorga mediante la aceptación de estos términos su consentimiento previo,
                    expreso, libre, voluntario e informado a la sociedad SYC TRADING S.A.S., en su condición de
                    Responsable del Tratamiento de Datos Personales, para que realice la recolección, almacenamiento,
                    uso, circulación, supresión, procesamiento, transferencia, transmisión y, en general, cualquier
                    operación de tratamiento sobre los datos personales suministrados de forma directa o indirecta a
                    través de esta plataforma web; datos que serán incorporados en las bases de datos de la compañía y
                    tratados con la finalidad de remitir notificaciones de carácter administrativo, legal o operativo,
                    enviar comunicaciones publicitarias, campañas de mercadeo, ofertas, promociones comerciales,
                    difundir boletines y avisos de interés particular o general para el receptor, y adelantar gestiones
                    enfocadas en medir, evaluar y mejorar la satisfacción y experiencia de los clientes, propósitos que
                    podrán ser ejecutados de manera directa por la empresa o en beneficio y desarrollo conjunto con
                    otras empresas relacionadas, filiales, subsidiarias, matrices, aliadas estratégicas o terceros
                    vinculados comercialmente, garantizando en todo momento la confidencialidad, seguridad y reserva de
                    la información; asimismo, el titular manifiesta expresamente que ha sido informado sobre los
                    derechos constitucionales y legales que le asisten —especialmente los de conocer, actualizar,
                    rectificar y solicitar la supresión de sus datos personales, así como revocar la presente
                    autorización de conformidad con los procedimientos ante la Superintendencia de Industria y
                    Comercio—, reconociendo y aceptando expresamente que el canal idóneo, expedito y directo establecido
                    por el Responsable para solicitar la supresión total o parcial de su información de las bases de
                    datos, o para revocar este consentimiento, consiste en comunicarse formalmente mediante un mensaje
                    escrito a la línea de atención autorizada vía WhatsApp al número 3217375018, solicitud que será
                    atendida bajo los términos, plazos y procedimientos previstos por la legislación colombiana vigente.
                </Typography>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Politica